'use client'

import { useEffect, useState } from 'react'
import {
	isCollectionInSnipeRollout,
	isSnipeProtectionOffered,
	type SecurePurchaseCapabilities,
	type SnipeProtectionOffer,
	type SecureAssetProtocol
} from './secure-purchase'
import type { SnipeAvailability } from './protection-support'

/**
 * Whether the API can build a protected listing for `protocol`.
 *
 * `probe_failed` is not `disabled`: a failed capabilities probe must block a
 * supported ordinal instead of looking like the feature flag is off. Asset
 * types protection does not cover still list standard. `disabled` means
 * the API answered and protection is not available (flag, policy, or this
 * protocol). Pass `collectionSlug` to also apply the rollout dial; omit it
 * when the caller checks each item's collection itself (import).
 */
export function useSnipeProtection(protocol: SecureAssetProtocol, collectionSlug?: string | null) {
	const [offer, setOffer] = useState<SnipeProtectionOffer | null>(null)

	useEffect(() => {
		let active = true
		isSnipeProtectionOffered(protocol).then((value) => {
			if (active) setOffer(value)
		})
		return () => {
			active = false
		}
	}, [protocol])

	const apiStatus: SnipeAvailability = offer?.status ?? 'loading'
	const status: SnipeAvailability =
		apiStatus === 'offered' &&
		collectionSlug !== undefined &&
		!isCollectionInSnipeRollout(collectionSlug)
			? 'disabled'
			: apiStatus
	const offered = status === 'offered'
	return {
		status,
		apiStatus,
		offered,
		enabled: offered,
		probeFailed: apiStatus === 'probe_failed',
		caps: offer?.caps as SecurePurchaseCapabilities | undefined,
		code: offer?.code
	}
}
